export default function TextLogo({ extraClasses }) {
  return (
    <span
      className={`text-700 text-primary font-bold font-['Montserrat',_sans-serif] | py-[10px] leading-tight | cursor-pointer ${extraClasses}`}
    >
      AIVerse
    </span>
  );
}
